// extracted by mini-css-extract-plugin
export default {"container":"loading_container__bPVzT"};